import script from "./phone_dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./phone_dialog.vue?vue&type=script&setup=true&lang=js"

import "./phone_dialog.vue?vue&type=style&index=0&id=3b94602b&lang=scss"

const __exports__ = script;

export default __exports__